import ImageClass from "../../src/shell/Image";
import Question from "../../src/shell/Questions";
import { jump } from "../../src/shell/jump";
import { ann } from "../characters/Ann";
import { chris } from "../characters/Chris";
import { empty } from "../characters/empty";
import { mc } from "../characters/MC";
import { strangerFemale } from "../characters/StrangerFemale";
import { images } from "./images";
import { V7AnnChrisMCMoviesAfter } from "./V7";
import { endReplay } from "../../src/shell/endReplay";
import { replayScenesList } from "../../src/components/menu/Scenes/replayScenes/scenesReplayData";


export const V7AnnChrisMCMovies = async (): Promise<any> => {
    await mc.set((properties) => {
        properties.v7AnnChrisMovieStatus = "went";
    });
    ImageClass.setImage(images.v7.V7PickingUpMC_0, { transition: true });
    mc.talk(`Here they are.`);
    ImageClass.setImage(images.v7.V7PickingUpMC_1);
    mc.talk(`Hey guys.`);
    chris.talk(`Yo Bro, get in! We're gonna be late.`);
    ImageClass.setImage(images.v7.V7PickingUpMC_2);
    ann.talk(`Are you excited? I know I am!`);
    mc.talk(`Haha.`);
    mc.talk(`So Chris, how did you manage to get an extra ticket?`);
    ImageClass.setImage(images.v7.V7PickingUpMC_3);
    chris.talk(`I haven't.`);
    mc.talk(`I'm confused. Ann said that you are able to get all of us inside.`);
    chris.talk(`We're gonna get inside but we'll have to share seats.`);
    chris.talk(`I know it's not the most comfortable thing but Ann insisted you come and that's the best that I could do.`);
    ImageClass.setImage(images.v7.V7PickingUpMC_2);
    ann.talk(`It will be ok! I'm just glad all of us are here.`);
    return jump(V7AnnChrisMCMovies2, "V7AnnChrisMCMovies2");
};

export const V7AnnChrisMCMovies2 = async (): Promise<any> => {
    // <!-- TODO: alpha render - Theater outside before entering - conversation with the cashier -->

    return jump(V7AnnChrisMCMovies3, "V7AnnChrisMCMovies3");
};

export const V7AnnChrisMCMovies3 = async (): Promise<any> => {
    ImageClass.setImage(images.v7.V7AnnChrisMovie_25, { transition: true });
    mc.think(`This is it... The movie Ann wanted to see.`);
    mc.think(`She wasn't kidding, the place is crowded.`);
    ImageClass.setImage(images.v7.V7AnnChrisMovie_26);
    ann.talk(`I can't believe I'm actually here!`);
    ImageClass.setImage(images.v7.V7AnnChrisMovie_27);
    ann.talk(`Thank you Chris!`);
    chris.talk(`Glad to help.`);
    mc.talk(`So, where are our seats?`);
    ImageClass.setImage(images.v7.V7AnnChrisMovie_27.partials.V7AnnChrisMovie_28_p);
    chris.talk(`In the far back... That's the best I could get.`);
    ann.talk(`It's perfect.`);
    ann.talk(`It's about to start!`);
    return jump(V7AnnChrisMCMovies3_Question, "V7AnnChrisMCMovies3_Question");

};

export const V7AnnChrisMCMovies3_Question = async (): Promise<any> => {
    await chris.setQuestion(new Question({ text: `Wait. We need to decided who is gonna share seats with Ann.`, options: { think: false }, key: `v7AnnChrisMoviesSatWithAnn` })
        .option({ title: `Ann and I will share a seat`, key: true })
        .option({ title: `You both can share a seat`, key: false }));


    if (Question.globalAnswers.v7AnnChrisMoviesSatWithAnn) {
        return jump(V7AnnChrisMCMovies3_Question_McShare, "V7AnnChrisMCMovies3_Question_McShare");

    } else {
        return jump(V7AnnChrisMCMovies3_Question_ChrisShare, "V7AnnChrisMCMovies3_Question_ChrisShare");

    }
};

export const V7AnnChrisMCMovies3_Question_McShare = async (): Promise<any> => {

    mc.talk(`Ann and I will share a seat.`);
    chris.talk(`Alright, let's go.`);
    ImageClass.setImage(images.v7.V7AnnChrisMovie_14);
    mc.think(`Ann sat on my lap as the movie started.`);
    mc.think(`Let's see what it's about.`);
    ImageClass.setImage(images.v2_5.BlackScreen, { duration: 0.6 });
    empty.think(`*An hour later*`);
    ImageClass.setImage(images.v7.V7AnnChrisMovie_14);
    mc.think(`This movie sucks! Who the hell is paying for this? Not my thing at all, but I came to show Ann I care for her.`);
    mc.think(`The only good thing about it are the sex scenes.`);
    return jump(V7AnnChrisMCMovies3_McShare_Question, "V7AnnChrisMCMovies3_McShare_Question");
};

export const V7AnnChrisMCMovies3_McShare_Question = async (): Promise<any> => {
    ImageClass.setImage(images.v7.V7AnnChrisMovie_14);
    await mc.setQuestion(new Question({ text: `I wonder if it made Ann horny as well...`, options: { think: true }, key: `v7AnnChrisMoviesTouchedAnn` })
        .option({ title: `Touch her`, key: true })
        .option({ title: `Don't touch her`, key: false }));


    if (Question.globalAnswers.v7AnnChrisMoviesTouchedAnn) {
        return jump(V7AnnChrisMCMovies3_McShare_Question_Touch, "V7AnnChrisMCMovies3_McShare_Question_Touch");

    } else {
        return jump(V7AnnChrisMCMovies3_McShare_Question_DontTouch, "V7AnnChrisMCMovies3_McShare_Question_DontTouch");

    }
};


export const V7AnnChrisMCMovies3_McShare_Question_Touch = async (): Promise<any> => {
    ImageClass.setImage(images.v7.V7AnnChrisMovie_18, { duration: 0.6 });
    await ann.set((properties) => {
        properties.corruption++;
    });
    mc.think(`I bet she is. She isn't resisting even one bit.`);
    mc.think(`I would have guessed that a theater full of people would make her think twice about what I'm doing, but nope.`);
    mc.think(`Ann's breathing is encouraging me to try and take it a step further.`);
    ImageClass.setImage(images.v7.V7AnnChrisMovie_17);
    ann.talk(`Ah...`);
    mc.think(`I don't think she is watching the movie at this point.`);
    mc.think(`I wonder what's going on in Chris's mind right now. He isn't saying anything, but I'm sure he regrets letting me join.`);
    mc.think(`But who fucking care?`);
    mc.think(`I kept going and touched her breast underneath her top.`);
    mc.think(`I continued massaging her breast and gently pinched her nipple.`);
    return jump(V7AnnChrisMCMovies3_McShare_Question_Touch_Question, "V7AnnChrisMCMovies3_McShare_Question_Touch_Question");

};

export const V7AnnChrisMCMovies3_McShare_Question_Touch_Question = async (): Promise<any> => {
    ImageClass.setImage(images.v7.V7AnnChrisMovie_17, { duration: 0.6 });
    await mc.setQuestion(new Question({ text: `She stayed quiet but I knew she was about to scream.`, options: { think: true }, key: `v7AnnChrisMoviesContinuedToTouchedAnn` })
        .option({ title: `Continue`, key: true })
        .option({ title: `Stop`, key: false }));


    if (Question.globalAnswers.v7AnnChrisMoviesContinuedToTouchedAnn) {
        return jump(V7AnnChrisMCMovies3_McShare_Question_Touch_Question_Continue, "V7AnnChrisMCMovies3_McShare_Question_Touch_Question_Continue");

    } else {
        return jump(V7AnnChrisMCMovies3_McShare_Question_Touch_Question_Stop, "V7AnnChrisMCMovies3_McShare_Question_Touch_Question_Stop");

    }
};


export const V7AnnChrisMCMovies3_McShare_Question_Touch_Question_Continue = async (): Promise<any> => {
    ImageClass.setImage(images.v7.V7AnnChrisMovie_15);
    await ann.set((properties) => {
        properties.corruption++;
    });
    mc.think(`Fuck she is so wet.`);
    ImageClass.setImage(images.v7.V7AnnChrisMovie_16);
    ann.talk(`Ah...`, { method: "Heavy Breathing" });

    ImageClass.setImage(images.v7.V7AnnChrisMovie_19);
    // <!-- TODO alpha animation -->
    ann.talk(`Ahhh...`);
    ImageClass.setImage(images.v7.V7AnnChrisMovie_21);
    strangerFemale.talk(`Can I watch the last two minutes of the movie in peace?!`);
    ImageClass.setImage(images.v7.V7AnnChrisMovie_22);
    ann.talk(`Oh. Sorry.`);
    strangerFemale.talk(`Jeez...`);
    mc.think(`Fuck that, I ain't gonna back down right now.`);
    ImageClass.setImage(images.v7.V7AnnChrisMovie_19);
    ann.talk(`${mc.name}! I can't!`, { method: "Whispering" });
    ImageClass.setImage(images.v7.V7AnnChrisMovie_19);
    ann.talk(`Ahh!`);
    mc.think(`She came quick.`);
    ImageClass.setImage(images.v7.V7AnnChrisMovie_14);
    mc.think(`Now she can watch the end of the movie.`);


    return jump(V7AnnChrisMCMovies5, "V7AnnChrisMCMovies5");
};

export const V7AnnChrisMCMovies3_McShare_Question_Touch_Question_Stop = async (): Promise<any> => {
    ImageClass.setImage(images.v7.V7AnnChrisMovie_14);
    mc.think(`That's enough fun for now.`);
    mc.think(`I'll just let her watch the end of the movie in peace.`);

    return jump(V7AnnChrisMCMovies5, "V7AnnChrisMCMovies5");
};

export const V7AnnChrisMCMovies3_McShare_Question_DontTouch = async (): Promise<any> => {
    ImageClass.setImage(images.v7.V7AnnChrisMovie_14);
    mc.think(`Nah... I won't touch her in public.`);
    mc.think(`Besides, I know how much she wanted to watch the movie, it would be rude to disturb her.`);
    mc.think(`We kept watching the movie until it ended...`);
    mc.think(`And fuck, it was boring... But at least I was a good boyfriend.`);

    return jump(V7AnnChrisMCMovies5, "V7AnnChrisMCMovies5");
};

export const V7AnnChrisMCMovies3_Question_ChrisShare = async (): Promise<any> => {
    await ann.set((properties) => {
        properties.corruption++;
    });
    mc.talk(`You both can share a seat.`);
    ImageClass.setImage(images.v7.V7AnnChrisMovie_27);
    chris.talk(`Alright, let's go.`);
    ImageClass.setImage(images.v7.V7AnnChrisMovie_0);
    mc.think(`I grabbed the empty sit while Ann sat on Chris's lap.`);
    mc.think(`Time to watch the movie.`);
    ImageClass.setImage(images.v2_5.BlackScreen, { duration: 0.6 });
    empty.think(`*An hour later*`);
    ImageClass.setImage(images.v7.V7AnnChrisMovie_0, { transition: true, duration: 0.6 });
    mc.think(`Fuck it's really not my thing.`);
    mc.think(`I doubt Chris is enjoying the movie as well...`);
    ImageClass.setImage(images.v7.V7AnnChrisMovie_1);
    mc.think(`Yup. Just as I thought, he doesn't give a shit about the movie and he is making a move on Ann.`);
    mc.think(`The movie is starting to heat up with more sex scenes.`);
    ImageClass.setImage(images.v7.V7AnnChrisMovie_2);
    mc.think(`Chris put his left hand on Ann's boob.`);
    mc.think(`She seems surprised but still keeps quiet.`);
    ImageClass.setImage(images.v7.V7AnnChrisMovie_4);
    mc.think(`Oh, wow. He is really going for it.`);

    return jump(V7AnnChrisMCMovies3_ChrisShare_Question, "V7AnnChrisMCMovies3_ChrisShare_Question");
};

export const V7AnnChrisMCMovies3_ChrisShare_Question = async (): Promise<any> => {
    ImageClass.setImage(images.v7.V7AnnChrisMovie_3);
    await mc.setQuestion(new Question({ text: `Ann is looking at me, I don't think she feels comfortable.`, options: { think: true }, key: `v7AnnChrisMoviesAgreeToChrisTouchingHer` })
        .option({ title: `Nod in agreement`, key: true })
        .option({ title: `Shake head in disapproval`, key: false }));


    if (Question.globalAnswers.v7AnnChrisMoviesAgreeToChrisTouchingHer) {
        return jump(V7AnnChrisMCMovies3_ChrisShare_Question_Nod, "V7AnnChrisMCMovies3_ChrisShare_Question_Nod");

    } else {
        return jump(V7AnnChrisMCMovies3_ChrisShare_Question_Shake, "V7AnnChrisMCMovies3_ChrisShare_Question_Shake");

    }
};


export const V7AnnChrisMCMovies3_ChrisShare_Question_Nod = async (): Promise<any> => {
    ImageClass.setImage(images.v7.V7AnnChrisMovie_3);
    mc.think(`*Nodding*`);
    ImageClass.setImage(images.v7.V7AnnChrisMovie_4);
    mc.think(`She went back to watching the movie while knowing I approved what was going on.`);
    return jump(V7AnnChrisMCMovies3_ChrisShare2, "V7AnnChrisMCMovies3_ChrisShare2");
};

export const V7AnnChrisMCMovies3_ChrisShare_Question_Shake = async (): Promise<any> => {
    ImageClass.setImage(images.v7.V7AnnChrisMovie_3);
    await ann.set((properties) => {
        properties.corruption++;
    });
    mc.think(`I showed my disapproval, but it didn't stop her from ignoring him and going back to watching the movie while Chris continued touching her.`);
    return jump(V7AnnChrisMCMovies3_ChrisShare2, "V7AnnChrisMCMovies3_ChrisShare2");
};

export const V7AnnChrisMCMovies3_ChrisShare2 = async (): Promise<any> => {
    ImageClass.setImage(images.v7.V7AnnChrisMovie_4);
    // TODO: add inner thoughts for Question.globalAnswers.v7AnnChrisMoviesAgreeToChrisTouchingHer == false
    mc.think(`I don't know if Chris realizes that I'm looking at them or not.`);
    mc.think(`And to be honest, I don't think he cares.`);
    ImageClass.setImage(images.v7.V7AnnChrisMovie_5);
    mc.think(`He put his hand closer to her pussy.`);
    mc.think(`Is he really going for it? Right here?`);
    mc.think(`I can't blame him, I guess I would have done the same.`);
    ImageClass.setImage(images.v7.V7AnnChrisMovie_6);
    ann.talk(`Ahh...`, { method: "Whispering" });
    ImageClass.setImage(images.v7.V7AnnChrisMovie_8);
    strangerFemale.talk(`Can you be quiet back there?! I'm trying to watch the end of the movie in peace!`);
    strangerFemale.talk(`Oh my God, get a room!`);
    ImageClass.setImage(images.v7.V7AnnChrisMovie_9);
    ann.talk(`Sorry!`);
    ImageClass.setImage(images.v7.V7AnnChrisMovie_10);
    chris.talk(`Shh... Ignore her.`);
    ImageClass.setImage(images.v7.Anim_V7AnnChrisMovie.poster);
    chris.talk(`Just relax and let yourself go.`, { method: "Whispering" });
    ImageClass.setAnimation(images.v7.Anim_V7AnnChrisMovie);
    mc.think(`He really wants her to cum no matter what.`);
    mc.think(`He should go faster, the movie is about the end.`);
    ImageClass.setImage(images.v7.V7AnnChrisMovie_12);
    ann.talk(`AH!`);
    chris.talk(`There it is.`);
    ann.talk(`Chris...`, { method: "Whispering" });

    return jump(V7AnnChrisMCMovies5, "V7AnnChrisMCMovies5");
};

export const V7AnnChrisMCMovies5 = async (): Promise<any> => {
    ImageClass.setImage(images.v7.V7AnnChrisMovie_23, { transition: true, duration: 0.6 });
    mc.think(`The movie is finally over.`);
    ann.talk(`I hope you enjoyed it! Hehe.`);
    if (Question.globalAnswers.v7AnnChrisMoviesSatWithAnn === false) {

        mc.think(`I bet Chris did.`);
    } else {

    }
    ann.talk(`Thanks for coming!`);
    ImageClass.setImage(images.v7.V7AnnChrisMovie_23.partials.V7AnnChrisMovie_24_p);
    ann.talk(`And thanks Chris for getting us the tickets!`);
    chris.talk(`What are friends for?`);
    chris.talk(`Anyway, my shift at the bar is about to start.\nI'll give you guys a lift and head there.`);
    ImageClass.setImage(images.v7.V7AnnChrisMovie_23);
    ann.talk(`${mc.name}, I'll come over to your place first thing in the morning to practice the audition!`);
    mc.talk(`Sure.`);
    ann.talk(`Thanks!`);
    ImageClass.setImage(images.v7.V7AnnChrisMovie_23.partials.V7AnnChrisMovie_24_p);
    ann.talk(`Let's go.`);
    await endReplay(replayScenesList.v7AnnMoviesChris);

    return jump(V7AnnChrisMCMoviesAfter, "V7AnnChrisMCMoviesAfter");
};


